import React, { useEffect } from "react";
import { toast } from "react-toastify";
import HabboImage from "./HabboImage";

const CREW = [
    { habbo: "Rhyss", gesture: "sml", action: "wav", direction: 4, head_direction: 3 },
    { habbo: "Steve", gesture: "sml", direction: 2, head_direction: 2 },
    { habbo: "Ads", gesture: "srp", direction: 4, head_direction: 4 },
    { habbo: "Sprig", gesture: "sml", action: "wav", direction: 2, head_direction: 3 },
    { habbo: "Cabbage", gesture: "std", direction: 4, head_direction: 4 },
    { habbo: "Chicka", gesture: "srp", direction: 2, head_direction: 2 },
    { habbo: "Fizz", gesture: "sml", direction: 4, head_direction: 4 },
    { habbo: "Nineteen", gesture: "std", direction: 2, head_direction: 3 },
    { habbo: "Skykira", gesture: "sml", action: "wav", direction: 4, head_direction: 4 },
    { habbo: "G30", gesture: "sml", direction: 2, head_direction: 2 },
];

const Maintenance = () => {
    const handleLogin = () => {
        let apiUrl = process.env.REACT_APP_API_URL;

        if (apiUrl.endsWith("/api/")) {
            apiUrl = apiUrl.slice(0, -5);
        } else if (apiUrl.endsWith("/api")) {
            apiUrl = apiUrl.slice(0, -4);
        }

        window.location.href = `${apiUrl}/api/auth/discord`;
    };

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const loginStatus = urlParams.get("login");
        const error = urlParams.get("error");

        if (loginStatus === "success") {
            toast.error("You don't have admin access.", {
                autoClose: 5000,
            });
            window.history.replaceState({}, document.title, window.location.pathname);
        } else if (error) {
            let errorMessage = "Login failed";

            switch (error) {
                case "no_code":
                    errorMessage = "No auth code";
                    break;
                case "not_verified":
                    errorMessage = "You're not verified with OriginsBot.";
                    break;
                case "no_staff_role":
                case "maintenance_mode":
                    errorMessage = "Only admins can log in while we're down for maintenance.";
                    break;
                case "auth_failed":
                    errorMessage = "Auth failed.";
                    break;
                default:
                    errorMessage = `Login failed: ${error}`;
            }

            toast.error(errorMessage, {
                autoClose: 5000,
            });
            window.history.replaceState({}, document.title, window.location.pathname);
        }
    }, []);

    return (
        <div
            className="min-h-screen bg-coal_dark flex items-center justify-center px-4 py-10"
            style={{
                backgroundImage: `
                      linear-gradient(rgba(20,20,20,0), rgba(20,20,20,0)),
                      url(${process.env.PUBLIC_URL}/img/grey_tile.png)
                    `,
                backgroundBlendMode: "soft-light",
                imageRendering: "pixelated",
            }}
        >
            <div className="w-full max-w-[640px] flex flex-col items-center gap-5">
                <img
                    src={`${process.env.PUBLIC_URL}/img/logo-beta.png`}
                    alt="FranklyOrigins Logo"

                />

                <div className="w-full bg-coal border-t-4 border-gold" style={{ boxShadow: "0 6px 0 0 rgba(0,0,0,0.4)" }}>
                    <div className="flex items-center gap-2 px-5 pt-5">
                        <span className="w-[10px] h-[10px] rounded-full bg-gold animate-pulse shrink-0" />
                        <span className="font-['Jersey_10'] text-gold text-[15px] uppercase tracking-[2px]">
                            System Maintenance In Progress
                        </span>
                    </div>

                    <div className="flex flex-col sm:flex-row gap-4 items-center sm:items-start px-5 pt-3">
                        <img
                            src={`https://files.habboemotion.com/resources/images/frank/frank_03.gif`}
                        />
                        <div className="text-center sm:text-left">
                            <h2 className="font-['Jersey_10'] text-offwhite text-[26px] leading-tight">
                                Frank's locked the front door.
                            </h2>
                            <p className="font-['Jersey_10'] text-offwhite text-[18px] opacity-80 mt-1">
                                The crew are round the back with their sleeves rolled up, fixing things that were
                                fine an hour ago. We won't be long.
                            </p>
                        </div>
                    </div>

                    <div className="px-5 pt-4">
                        <p className="font-['Jersey_10'] text-offwhite text-[18px] opacity-70">
                            Follow along or say hello in the Discord while you wait, that's usually where we post
                            updates first.
                        </p>
                    </div>

                    <div className="px-5 pt-4">
                        <a
                            href="https://discord.gg/vehU36G44N"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="w-full border border-gold flex items-center justify-center gap-2 text-white font-['Jersey_10'] uppercase text-[17px] tracking-[1px] px-3 py-2 transition-all hover:bg-black hover:bg-opacity-25"
                            style={{
                                textShadow:
                                    "-1px -1px 0 rgba(0,0,0,0.5), 1px -1px 0 rgba(0,0,0,0.5), -1px 1px 0 rgba(0,0,0,0.5), 1px 1px 0 rgba(0,0,0,0.5)",
                            }}
                        >
                            Join Our Discord
                        </a>
                    </div>

                    <div className="mt-5 border-t border-white/10 bg-black/20">
                        <div className="flex flex-wrap justify-center gap-x-1 gap-y-2 px-4 pt-4">
                            {CREW.map((member, i) => (
                                <HabboImage
                                    key={member.habbo}
                                    habbo={member.habbo}
                                    custom="frank_hat"
                                    gesture={member.gesture}
                                    action={member.action || ""}
                                    direction={member.direction}
                                    head_direction={member.head_direction}
                                    style={{ transform: `translateY(${i % 2 === 0 ? "0px" : "6px"})` }}
                                />
                            ))}
                        </div>
                        <p className="font-['Jersey_10'] text-offwhite text-[15px] opacity-60 text-center pt-1 pb-4">
                            - Rhyss, Steve and the Frankly Team!
                        </p>
                    </div>
                </div>

                <button
                    onClick={handleLogin}
                    className="text-sm font-['Jersey_10'] text-offwhite opacity-60 hover:opacity-100 underline"
                >
                    Admin Login
                </button>
            </div>
        </div>
    );
};

export default Maintenance;
